import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clickExplanationIconTrigger from '@coolblue-development/ga4-events/triggers/InsuranceSelector/clickExplanationIconTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ExplanationIcon } from '@coolblue-development/next-patterns/client';
import { useId, useRef, useState } from 'react';
import { InsuranceProvider } from '../types.js';
import InsuranceDetailsModal from './InsuranceDetailsModal.js';
export function InsuranceExplanationIcon({ insuranceProductId, insuranceQuoteId, productId, title, modalAction, trackingSubFeature, provider, }) {
    const [open, setOpen] = useState(false);
    const { trackEvent } = useAnalytics();
    const dialogId = useId();
    const triggerRef = useRef(null);
    function handleExplanationLinkClick() {
        setOpen(true);
        if (!trackingSubFeature)
            return;
        trackEvent(clickExplanationIconTrigger({
            sub_feature: trackingSubFeature,
            subject_id: provider === InsuranceProvider.ERGO ? insuranceProductId : insuranceQuoteId || '',
        }));
    }
    function getInsuranceId() {
        switch (provider) {
            case InsuranceProvider.ERGO:
                return insuranceProductId;
            default:
                return insuranceQuoteId;
        }
    }
    function handleClose() {
        setOpen(false);
        //Timeout to ensure focus is set after modal close animation
        setTimeout(() => {
            var _a;
            (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 0);
    }
    return (_jsxs(_Fragment, { children: [_jsx(ExplanationIcon, { testId: "insurance-explanation-icon", onClick: handleExplanationLinkClick, dialogId: dialogId, ref: triggerRef }), _jsx(InsuranceDetailsModal, { open: open, onClose: handleClose, insuranceId: getInsuranceId(), productId: productId, provider: provider, title: title, action: modalAction, dialogId: dialogId })] }));
}
export default InsuranceExplanationIcon;
//# sourceMappingURL=InsuranceExplanationIcon.js.map